import { gql } from "@apollo/client"

const TEXT_JOB_STEP_FIELDS = gql`
  fragment TextJobStepFields on TextJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { TEXT_JOB_STEP_FIELDS }
